import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    toasts: {
        type: '',
        title: '',
        message: ''
    }
}

const toastSlice = createSlice({
    name: "toasts",
    initialState,
    reducers:{
        showToast: (state, action)=>{                
            state.toasts ={
                type: action.payload?.type,
                title: action.payload?.title,
                message: action.payload?.message
            }       
        },
        removeToast:(state)=>{
            state.toasts ={
                type: '',
                title: '',
                message: ''
            }   
        },
    },
});

export const {showToast, removeToast }=  toastSlice.actions;
export default toastSlice.reducer;